import { render } from "./ButtonIcon_dual_status.vue?vue&type=template&id=754b84fa"
import script from "./ButtonIcon_dual_status.vue?vue&type=script&lang=js"
export * from "./ButtonIcon_dual_status.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__